import React from 'react';

import PropTypes from 'prop-types';

function createThemeProvider(defaultTheme, ThemeContext) {
  return class ThemeProvider extends React.Component {
    static propTypes = {
      theme: PropTypes.any,
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    };
    static defaultProps = {
      theme: defaultTheme,
    };

    render() {
      const { theme, children } = this.props;
      return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
    }
  };
}

export default createThemeProvider;
